import React from 'react';

const ScribbleUnderline = ({ delay = 0 }) => (
<svg
  className="absolute -bottom-2 left-0 w-full h-4"
  viewBox="0 0 200 15"
  fill="none"
  style={{
    animation: `drawUnderline 1.2s ease-out ${delay}s forwards`,
    opacity: 0,
  }}
>
  <path
    d="M3 10 
       Q 25 4, 45 9 
       T 90 10 
       Q 120 6, 150 10 
       T 195 9"
    stroke="#00FFC6"
    strokeWidth="3.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />

  <style>{`
    @keyframes drawUnderline {
      from {
        stroke-dasharray: 300;
        stroke-dashoffset: 300;
        opacity: 0;
      }
      to {
        stroke-dasharray: 300;
        stroke-dashoffset: 0;
        opacity: 1;
      }
    }
  `}</style>
</svg>

);

export default ScribbleUnderline;